<template>
  <div class="help-root">

    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">groups</span>
      <p>
        Gestiona las interconsultas de una atención específica: crea solicitudes
        a otras especialidades, edita el motivo y cuadro clínico, y genera los
        formularios oficiales en PDF.
      </p>
    </div>

    <!-- Datos de la atención -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">article</span>
        Datos de la atención (solo lectura)
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in datosAtencion" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Dictado por voz -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">mic</span>
        Dictado por voz
      </h3>
      <div class="help-voz">
        <div class="help-voz-item">
          <span class="material-symbols-outlined" style="color:orangered;font-size:28px">mic_off</span>
          <p class="help-card-desc">Micrófono <strong>inactivo</strong>. Pulsa para iniciar el dictado en el campo Motivo o Cuadro.</p>
        </div>
        <div class="help-voz-item">
          <span class="material-symbols-outlined" style="color:green;font-size:28px">mic</span>
          <p class="help-card-desc">Micrófono <strong>activo</strong>. El sistema está transcribiendo tu voz. Pulsa para detener.</p>
        </div>
      </div>
    </section>

    <!-- Opciones por fila -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Opciones por interconsulta
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Restricción por estado -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">lock</span>
        Restricciones por estado de la atención
      </h3>
      <div class="help-estados" style="margin-bottom:0.5rem">
        <span class="help-estado-badge" style="background:#fff3cd;color:#856404">PENDIENTE</span>
        <span class="help-estado-badge" style="background:#cce5ff;color:#004085">PROCESO</span>
      </div>
      <p class="help-card-desc" style="padding:0 0.25rem">
        Las acciones <strong>Nueva interconsulta</strong>, <strong>Editar</strong> y
        <strong>Borrar</strong> solo están disponibles cuando la atención está en
        estado <strong>PENDIENTE</strong> o <strong>PROCESO</strong>. En cualquier
        otro estado solo se pueden consultar los detalles y generar los PDFs.
      </p>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>
        Al crear una interconsulta, primero selecciona la especialidad para que
        el sistema cargue solo los médicos disponibles de esa especialidad en
        la empresa.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "AyudaAtencionInterconsulta",
  data() {
    return {
      datosAtencion: [
        {
          icon: "person",
          titulo: "Paciente y cédula",
          desc:   "Nombre completo y número de documento del paciente de la atención. No es editable desde esta pantalla.",
        },
        {
          icon: "stethoscope",
          titulo: "Médico y especialidad",
          desc:   "Médico tratante y especialidad de la atención de origen. No es editable desde esta pantalla.",
        },
        {
          icon: "text_snippet",
          titulo: "Motivo y observación",
          desc:   "Descripción del motivo de consulta y observaciones registradas en la atención principal.",
        },
        {
          icon: "expand_more",
          titulo: "Más información",
          desc:   "Despliega el ID de la atención y las fechas de registro y última actualización.",
        },
      ],
      acciones: [
        {
          icon:   "add_circle",
          color:  "#0059cc",
          titulo: "Nueva interconsulta",
          desc:   "Abre el formulario para crear una interconsulta: selecciona la especialidad, el médico de destino, e ingresa el motivo y cuadro clínico. Solo disponible en atenciones PENDIENTE o PROCESO.",
        },
        {
          icon:   "edit",
          color:  "#198754",
          titulo: "Editar",
          desc:   "Abre el formulario para modificar la especialidad, médico, motivo o cuadro clínico de la interconsulta. Solo disponible en atenciones PENDIENTE o PROCESO.",
        },
        {
          icon:   "edit_note",
          color:  "#6f42c1",
          titulo: "Detalles",
          desc:   "Navega al formulario completo de la interconsulta de origen para revisar o completar toda la información clínica registrada.",
        },
        {
          icon:   "picture_as_pdf",
          color:  "#dc3545",
          titulo: "Formulario 007 — Solicitud",
          desc:   "Genera y descarga en PDF el Formulario 007 de solicitud de interconsulta para su impresión o archivo.",
        },
        {
          icon:   "picture_as_pdf",
          color:  "#dc3545",
          titulo: "Formulario 007 — Informe",
          desc:   "Genera y descarga en PDF el Formulario 007 con el informe de respuesta de la interconsulta.",
        },
        {
          icon:   "delete",
          color:  "#dc3545",
          titulo: "Borrar",
          desc:   "Elimina la interconsulta de forma permanente. Solo disponible en atenciones PENDIENTE o PROCESO.",
        },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>
